export default {
  items: [
    {title: 'Dashboard', path: '/dashboard', icon: 'dashboard', roles: ['ROLE_OFFICER']},
    {title: 'Quotations', path: '/quotations', icon: 'monetization_on', roles: ['ROLE_ADMIN', 'ROLE_OFFICER']},
    {title: 'Invoices', path: '/invoices', icon: 'payment', roles: ['ROLE_ADMIN', 'ROLE_OFFICER']},
    {title: 'Receipts', path: '/receipts', icon: 'receipt', roles: ['ROLE_ADMIN', 'ROLE_OFFICER']},
    {title: 'Cash Bills', path: '/cashBills', icon: 'file_copy', roles: ['ROLE_ADMIN', 'ROLE_OFFICER']},
    {title: 'Customers', path: '/customers', icon: 'people', roles: ['ROLE_ADMIN', 'ROLE_OFFICER']},
    {title: 'Officers', path: '/officers', icon: 'person', roles: ['ROLE_ADMIN', 'ROLE_OFFICER']},
    {title: 'Gangs', path: '/gangs', icon: 'group', roles: ['ROLE_ADMIN', 'ROLE_OFFICER']},
    {title: 'Reports', path: '/reports', icon: 'subject', roles: ['ROLE_ADMIN', 'ROLE_OFFICER']}
  ]
}



// WEBPACK FOOTER //
// ./src/config/menu.js